import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { RecentVisitors, Props as WidgetProps } from './RecentVisitors';
import reduxConnectContainer from './RecentVisitors.container';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';

const enhance = compose(
  reduxConnectContainer,
  withTranslation()
);

class RecentVisitorsBoxWide extends React.Component<
  WidgetProps & WidgetBoxWideProps & WithTranslation
> {
  render() {
    const {
      id,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      widgetMenuRenderer,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      parentRef,
      widgetBoxClassName,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        moduleId={props.moduleId}
        id={id}
        header={props.t!(`widgets.visitors.header`)}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        widgetMenuRenderer={widgetMenuRenderer}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
        parentRef={parentRef}
        emptyView={null}
      >
        <RecentVisitors {...props} />
      </WidgetBoxWide>
    );
  }
}
export default enhance(RecentVisitorsBoxWide) as React.ComponentType<{}>;
